module.exports = {
  async postUserEnvironmentFeedback(params) {
    const url = `${this.url}/${this.version}/user/environment_feedbacks`;
    const response = await this.post(url, params, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/user_environment_feedback_api.js